export enum OrderValidityTypeEnum {
    UNDEFINED = 47,
    DAY,
    GOODTILLCANCEL,
    IMMEDIATEORCANCEL,
    FILLORKILL,
    GOODTILLDATE = 54,
    ATTHECLOSE,
    GOODFORAUCTION
}